import { render, staticRenderFns } from "./WebchatEdit.vue?vue&type=template&id=a21a07ee&scoped=true&"
import script from "./WebchatEdit.vue?vue&type=script&lang=js&"
export * from "./WebchatEdit.vue?vue&type=script&lang=js&"
import style0 from "./WebchatEdit.vue?vue&type=style&index=0&id=a21a07ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21a07ee",
  null
  
)

export default component.exports